module.exports = __webpack_public_path__ + "static/media/backgroundVideoCompresse.cb981572.mp4";